export default "__VITE_ASSET__550ee34f__"